'use client'

import { hasDelmanDevice } from '@/shared/auth/delmanDeviceStorage'
import { hasDelmanSession } from '@/shared/auth/delmanSessionStorage'
import { ClientRedirect } from '@/shared/components/ClientRedirect'
import { useClientHydrated } from '@/shared/hooks/useClientHydrated'

export function DelmanEntryRedirect() {
  const hydrated = useClientHydrated()

  if (!hydrated) {
    return (
      <div className="min-h-[200px] flex items-center justify-center" aria-busy>
        <span className="material-symbols-outlined text-primary text-3xl animate-spin">progress_activity</span>
      </div>
    )
  }

  if (!hasDelmanDevice()) {
    return <ClientRedirect href="/delman/activate" />
  }
  if (!hasDelmanSession()) {
    return <ClientRedirect href="/delman/login" />
  }
  return <ClientRedirect href="/delman/trip" />
}
